import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d952a0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-list" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { class: "report-table" }
const _hoisted_4 = { class: "remark-cell" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "paginationCont" }
const _hoisted_10 = { class: "operationCont" }
const _hoisted_11 = { class: "report-table" }
const _hoisted_12 = { class: "remark-cell" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "paginationCont" }

import { reactive, ref, onMounted, onUnmounted, nextTick, watch } from 'vue';
import { FormInstance, ElMessage } from 'element-plus';
import { Search, RefreshRight } from '@element-plus/icons-vue';
import { getListCompanyInfo, customerReportPageList } from './api'
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const activeTab = ref('insurance');
const talentArr = ref<any>([]);
const talentArrClaim = ref<any>([]);
const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);

const calculateTableRows = () => {
  const tableContainer = document.querySelector('.report-table');
  if (!tableContainer) return;

  const allRows = document.querySelectorAll('.el-table__row');
  if (!allRows.length) {
    if (!hasInitialSearch.value) {
      hasInitialSearch.value = true;
      onSearch(false);
      onClaimSearch(false);
    }
    return;
  }

  // 计算新的 pageSize
  const totalHeight = Array.from(allRows).reduce((sum, row) => {
    return sum + row.getBoundingClientRect().height;
  }, 0);
  const rowHeight = totalHeight / allRows.length;

  const containerHeight = tableContainer.clientHeight;
  const maxRows = Math.floor(containerHeight / rowHeight);

  if (maxRows > 10) {
    const calculatedSize = Math.ceil(maxRows / 5) * 5;
    pageSizes.value = [calculatedSize, calculatedSize * 2, calculatedSize * 3];

    defaultPageSize.value = calculatedSize;
    queryForm.pageSize = calculatedSize;
    claimQueryForm.pageSize = calculatedSize;

    // 设置标志位并执行搜索
    hasInitialSearch.value = true;
    onSearch(true);
    onClaimSearch(true);
  }
};
const defaultPageSize = ref(10);
// 投保采集表单
const queryForm = reactive({
  condition: {
    companyCode: '',
    status: '',
    orderNo: '',
    targetNo: '',
    dateRange: [],
    reportType: '1'
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value
});

// 理赔验标表单
const claimQueryForm = reactive({
  condition: {
    companyCode: '',
    status: '',
    caseNo: '',
    targetNo: '',
    dateRange: [],
    reportType: '2'
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value
});

const tableData = ref([]);
const claimTableData = ref([]);
const total = ref(0);
const claimTotal = ref(0);
const queryFormRef = ref<FormInstance>();
const claimFormRef = ref<FormInstance>();

onMounted(() => {
  const savedState = sessionStorage.getItem('reportPageState');
  if (savedState) {
    const state = JSON.parse(savedState);
    activeTab.value = state.activeTab || 'insurance';
    if (state.insurance) {
      queryForm.pageIndex = state.insurance.pageIndex || 1;
      queryForm.pageSize = state.insurance.pageSize || defaultPageSize.value;
      queryForm.condition = state.insurance.condition || queryForm.condition;
    }
    if (state.claim) {
      claimQueryForm.pageIndex = state.claim.pageIndex || 1;
      claimQueryForm.pageSize = state.claim.pageSize || defaultPageSize.value;
      claimQueryForm.condition = state.claim.condition || claimQueryForm.condition;
    }
  }
  // 等待 DOM 渲染完成后再计算
  nextTick(() => {
    calculateTableRows();
    if (!hasInitialSearch.value) {
      onSearch(true);
      onClaimSearch(true);
    }
  });
  getCompanyList();
  window.addEventListener('resize', debounce(calculateTableRows, 200));
});
onUnmounted(() => {
  window.removeEventListener('resize', calculateTableRows);
});
const debounce = (fn: Function, delay: number) => {
  let timer: any = null;
  return function (this: any, ...args: any[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};
const getCompanyList = () => {
  getListCompanyInfo().then((res: any) => {
    console.log(res);
    talentArr.value = res;
    talentArrClaim.value = res;
  });
};;
const handleCompanyChange = (value: string) => {
  queryForm.condition.companyCode = value
}
const handleClaimCompanyChange = (value: string) => {
  claimQueryForm.condition.companyCode = value;
};
// 投保采集
const onSearch = async (isReset: boolean) => {
  if (isReset) {
    queryForm.pageIndex = 1;
  }

  // 准备查询参数
  const params = {
    condition: {
      compCode: queryForm.condition.companyCode,
      status: queryForm.condition.status,
      orderNo: queryForm.condition.orderNo,
      targetNo: queryForm.condition.targetNo,
      startDate: queryForm.condition.dateRange?.[0] || '',
      endDate: queryForm.condition.dateRange?.[1] || '',
      reportType: queryForm.condition.reportType,
    },
    pageIndex: queryForm.pageIndex,
    pageSize: queryForm.pageSize
  };

  try {
    const res = await customerReportPageList(params);
    if (res && res.items) {
      tableData.value = res.items;
      total.value = Number(res.totalSize);
    } else {
      ElMessage.error('数据格式错误');
    }
  } catch (error) {
    console.error('查询失败:', error);
    ElMessage.error('查询失败，请稍后再试');
  }
};


// 理赔验标
const onClaimSearch = async (isReset: boolean) => {
  if (isReset) {
    claimQueryForm.pageIndex = 1;
  }

  // 准备查询参数
  const params = {
    condition: {
      compCode: claimQueryForm.condition.companyCode,
      status: claimQueryForm.condition.status,
      caseNo: claimQueryForm.condition.caseNo,
      targetNo: claimQueryForm.condition.targetNo,
      startDate: claimQueryForm.condition.dateRange?.[0] || '',
      endDate: claimQueryForm.condition.dateRange?.[1] || '',
      reportType: claimQueryForm.condition.reportType,
    },
    pageIndex: claimQueryForm.pageIndex,
    pageSize: claimQueryForm.pageSize
  };

  try {
    const res = await customerReportPageList(params);
    if (res && res.items) {
      claimTableData.value = res.items;
      claimTotal.value = Number(res.totalSize);
    } else {
      ElMessage.error('数据格式错误');
    }
  } catch (error) {
    console.error('查询失败:', error);
    ElMessage.error('查询失败，请稍后再试');
  }
};


const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();

  if (activeTab.value === 'insurance') {
    queryForm.compCode = '';
    queryForm.condition = {
      companyCode: '',
      status: '',
      orderNo: '',
      targetNo: '',
      dateRange: [],
      reportType: '1'
    };
    onSearch(true);
  } else {
    claimQueryForm.compCode = '';
    claimQueryForm.condition = {
      companyCode: '',
      status: '',
      caseNo: '',
      targetNo: '',
      dateRange: [],
      reportType: '2'
    };
    onClaimSearch(true);
  }
};

// 投保采集分页
const handleSizeChange = (val: number) => {
  queryForm.pageSize = val;
  onSearch(true);
};

const handleCurrentChange = (val: number) => {
  queryForm.pageIndex = val;
  onSearch(false);
};

// 理赔验标分页
const handleClaimSizeChange = (val: number) => {
  claimQueryForm.pageSize = val;
  onClaimSearch(true);
};

const handleClaimCurrentChange = (val: number) => {
  claimQueryForm.pageIndex = val;
  onClaimSearch(false);
};

// 投保采集操作方法
const handleProcess = (row: any) => {
  router.push({
    name: 'CustomerReportProcess',
    query: {
      id: row.id,
      targetId: row.targetId,
    }
  });
};

const handleView = (row: any) => {
  router.push({
    name: 'CustomerReportProcess',
    query: {
      id: row.id,
      targetId: row.targetId,
      readonly: 'true',
      status: row.status
    }
  });
};

// 理赔验标操作方法
const handleClaimProcess = (row: any) => {
  router.push({
    name: 'CustomerClaimReportProcess',
    query: {
      id: row.id,
      targetId: row.targetId,
    }
  });
};

const handleClaimView = (row: any) => {
  router.push({
    name: 'CustomerClaimReportProcess',
    query: {
      id: row.id,
      targetId: row.targetId,
      readonly: 'true',
      status: row.status
    }
  });
};

const updateSessionStorage = () => {
  const state = {
    activeTab: activeTab.value,
    insurance: {
      pageIndex: queryForm.pageIndex,
      pageSize: queryForm.pageSize,
      // 如有需要，也可以存入其他查询条件
      condition: queryForm.condition
    },
    claim: {
      pageIndex: claimQueryForm.pageIndex,
      pageSize: claimQueryForm.pageSize,
      condition: claimQueryForm.condition
    }
  };
  sessionStorage.setItem('reportPageState', JSON.stringify(state));
};

watch(
  [activeTab, () => queryForm.pageIndex, () => queryForm.pageSize, () => claimQueryForm.pageIndex, () => claimQueryForm.pageSize],
  () => {
    updateSessionStorage();
  }
);

// 如果查询条件也需要保存，则可以增加对 queryForm.condition 和 claimQueryForm.condition 的监听
watch(
  () => queryForm.condition,
  () => {
    updateSessionStorage();
  },
  { deep: true }
);

watch(
  () => claimQueryForm.condition,
  () => {
    updateSessionStorage();
  },
  { deep: true }
);


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((activeTab).value = $event)),
      class: "report-tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "投保采集上报",
          name: "insurance"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form, {
                inline: true,
                model: queryForm,
                class: "demo-form-inline",
                ref_key: "queryFormRef",
                ref: queryFormRef
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "租户",
                    prop: "condition.companyCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: queryForm.compCode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.compCode) = $event)),
                        placeholder: "请选择租户",
                        clearable: "",
                        style: {"width":"100%"},
                        onChange: handleCompanyChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(talentArr.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.compCode,
                              label: item.compName,
                              value: item.compCode
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "处理状态",
                    prop: "condition.status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: queryForm.condition.status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.condition.status) = $event)),
                        placeholder: "全部",
                        clearable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "已取消",
                            value: "0"
                          }),
                          _createVNode(_component_el_option, {
                            label: "待处理",
                            value: "1"
                          }),
                          _createVNode(_component_el_option, {
                            label: "已处理",
                            value: "2"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "采集订单号",
                    prop: "condition.orderNo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: queryForm.condition.orderNo,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.condition.orderNo) = $event)),
                        clearable: "",
                        placeholder: "采集订单号",
                        style: {"width":"200px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "标的号",
                    prop: "condition.targetNo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: queryForm.condition.targetNo,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.condition.targetNo) = $event)),
                        clearable: "",
                        placeholder: "标的号",
                        style: {"width":"200px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "上报时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: queryForm.condition.dateRange,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.condition.dateRange) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        format: "YYYY-MM-DD",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: _unref(Search),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (onSearch(true)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查 询")
                        ]),
                        _: 1
                      }, 8, ["icon"]),
                      _createVNode(_component_el_button, {
                        icon: _unref(RefreshRight),
                        plain: "",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (resetForm(queryFormRef.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("重 置")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_table, {
                data: tableData.value,
                border: "",
                style: {"width":"100%"},
                height: "100%"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "reportNo",
                    label: "任务ID",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "compName",
                    label: "租户",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "reportType",
                    label: "任务类型",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.reportType === '1' ? '投保' : scope.row.reportType === '2' ? '理赔' : '未知'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "orderNo",
                    label: "采集订单号",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "targetNo",
                    label: "标的号",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "remark",
                    label: "上报情况备注",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: scope.row.remark ? scope.row.remark : '-无情况备注内容-',
                        placement: "top",
                        "show-after": 200
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, _toDisplayString(scope.row.remark ? scope.row.remark : '-无情况备注内容-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "reportTime",
                    label: "上报时间",
                    align: "center",
                    width: "180"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "status",
                    label: "处理状态",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, [
                        (scope.row.status === '0')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "已取消"))
                          : (scope.row.status === '1')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "待处理"))
                            : (scope.row.status === '2')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "已处理"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, "未知状态"))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "handleResultFeedback",
                    label: "处理结果反馈",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: scope.row.handleResultFeedback === '1' ? 'red' : 'inherit' })
                      }, _toDisplayString(scope.row.handleResultFeedback === '1' ? '有争议' : scope.row.handleResultFeedback === '0' ? '无争议' :
                    ''), 5)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    fixed: "right",
                    label: "操作",
                    width: "120",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.status === '1')
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            link: "",
                            type: "primary",
                            size: "small",
                            onClick: ($event: any) => (handleProcess(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 去处理 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            link: "",
                            type: "primary",
                            size: "small",
                            onClick: ($event: any) => (handleView(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 查看 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_pagination, {
                background: "",
                layout: "total, sizes, prev, pager, next",
                "page-sizes": pageSizes.value,
                total: total.value,
                "current-page": queryForm.pageIndex,
                "onUpdate:current-page": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.pageIndex) = $event)),
                "page-size": queryForm.pageSize,
                "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.pageSize) = $event)),
                onSizeChange: handleSizeChange,
                onCurrentChange: handleCurrentChange
              }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "理赔验标上报",
          name: "claim"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_form, {
                inline: true,
                model: claimQueryForm,
                class: "demo-form-inline",
                ref_key: "claimFormRef",
                ref: claimFormRef
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "租户",
                    prop: "condition.companyCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: claimQueryForm.compCode,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((claimQueryForm.compCode) = $event)),
                        placeholder: "请选择租户",
                        clearable: "",
                        style: {"width":"100%"},
                        onChange: handleClaimCompanyChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(talentArrClaim.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.compCode,
                              label: item.compName,
                              value: item.compCode
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "处理状态",
                    prop: "condition.status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: claimQueryForm.condition.status,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((claimQueryForm.condition.status) = $event)),
                        placeholder: "全部",
                        clearable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "已取消",
                            value: "0"
                          }),
                          _createVNode(_component_el_option, {
                            label: "待处理",
                            value: "1"
                          }),
                          _createVNode(_component_el_option, {
                            label: "已处理",
                            value: "2"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "案件号",
                    prop: "condition.caseNo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: claimQueryForm.condition.caseNo,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((claimQueryForm.condition.caseNo) = $event)),
                        clearable: "",
                        placeholder: "案件号",
                        style: {"width":"200px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "标的号",
                    prop: "condition.targetNo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: claimQueryForm.condition.targetNo,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((claimQueryForm.condition.targetNo) = $event)),
                        clearable: "",
                        placeholder: "标的号",
                        style: {"width":"200px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "上报时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: claimQueryForm.condition.dateRange,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((claimQueryForm.condition.dateRange) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        format: "YYYY-MM-DD",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: _unref(Search),
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (onClaimSearch(true)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查 询")
                        ]),
                        _: 1
                      }, 8, ["icon"]),
                      _createVNode(_component_el_button, {
                        icon: _unref(RefreshRight),
                        plain: "",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (resetForm(claimFormRef.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("重 置")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_table, {
                data: claimTableData.value,
                border: "",
                style: {"width":"100%"},
                height: "100%"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "reportNo",
                    label: "任务ID",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "compName",
                    label: "租户",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "reportType",
                    label: "任务类型",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.reportType === '1' ? '投保' : scope.row.reportType === '2' ? '理赔' : '未知'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "caseNo",
                    label: "案件号",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "targetNo",
                    label: "标的号",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "remark",
                    label: "上报情况备注",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: scope.row.remark ? scope.row.remark : '-无情况备注内容-',
                        placement: "top",
                        "show-after": 200
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(scope.row.remark ? scope.row.remark : '-无情况备注内容-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "reportTime",
                    label: "上报时间",
                    align: "center",
                    width: "180"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "status",
                    label: "处理状态",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, [
                        (scope.row.status === '0')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "已取消"))
                          : (scope.row.status === '1')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "待处理"))
                            : (scope.row.status === '2')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "已处理"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, "未知状态"))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "handleResultFeedback",
                    label: "处理结果反馈",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: scope.row.handleResultFeedback === '1' ? 'red' : 'inherit' })
                      }, _toDisplayString(scope.row.handleResultFeedback === '1' ? '有争议' : scope.row.handleResultFeedback === '0' ? '无争议' :
                    ''), 5)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    fixed: "right",
                    label: "操作",
                    width: "120",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.status === '1')
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            link: "",
                            type: "primary",
                            size: "small",
                            onClick: ($event: any) => (handleClaimProcess(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 去处理 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            link: "",
                            type: "primary",
                            size: "small",
                            onClick: ($event: any) => (handleClaimView(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 查看 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_pagination, {
                background: "",
                layout: "total, sizes, prev, pager, next",
                "page-sizes": pageSizes.value,
                total: claimTotal.value,
                "current-page": claimQueryForm.pageIndex,
                "onUpdate:current-page": _cache[16] || (_cache[16] = ($event: any) => ((claimQueryForm.pageIndex) = $event)),
                "page-size": claimQueryForm.pageSize,
                "onUpdate:page-size": _cache[17] || (_cache[17] = ($event: any) => ((claimQueryForm.pageSize) = $event)),
                onSizeChange: handleClaimSizeChange,
                onCurrentChange: handleClaimCurrentChange
              }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})